import { OVERVIEW_FRAGMENT } from '@atlassian/jira-business-entity-overview-utils/src/constants.tsx';

export const QUERY = `
    query JwmOverviewDetails($id:ID!) {
      jira {
        overview: jwmOverview(id: $id) {
          __typename
          ... on JiraWorkManagementGiraOverview {
            ...OverviewGiraFragment
          }
          ... on QueryError {
            message
            extensions {
              errorType
              statusCode
            }
          }
        }
      }
    }
    ${OVERVIEW_FRAGMENT}
`;
